import { IDocFieldHandler } from "./IDocFieldHandler";
import { IDHFSectionOptions } from "../../PluginManagerDocuments";
import { IReference } from "../../../../globals";
import { ItemSelectionAbstractDocFieldHandler } from "./ItemSelectionAbstractDocFieldHandler";

export interface IItemTableOptions extends IDHFSectionOptions {
    includeInToc: boolean;
    sortedList: boolean;
    includeFolders: boolean;
    columns: string;
    search?: string;
}

export class ItemTableDocFieldHandler extends ItemSelectionAbstractDocFieldHandler implements IDocFieldHandler {
    getDefaultConfig(): IItemTableOptions {
        return {
            includeInToc: false,
            sortedList: false,
            includeFolders: false,
            columns: "item,labels,down",
        };
    }

    getXmlValue(): string {
        let reflist = <IReference[]>this.getItems();

        for (let idx = 0; idx < reflist.length; idx++) {
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<IItemTableOptions>(<any>reflist[idx]))["includeInToc"] = this.dhfFieldConfig.includeInToc;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<IItemTableOptions>(<any>reflist[idx]))["includeFolders"] = this.dhfFieldConfig.includeFolders;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<IItemTableOptions>(<any>reflist[idx]))["sortedList"] = this.dhfFieldConfig.sortedList;
            // TODO: MATRIX-7555: lint errors should be fixed for next line
            // eslint-disable-next-line
            (<IItemTableOptions>(<any>reflist[idx]))["columns"] = this.dhfFieldConfig.columns;
        }

        return JSON.stringify(reflist);
    }
}
